// ============================================================
// CAMMINARE IN TUTTE LE DIREZIONI CON LE SOLE CLIP DEL MODELLO.
//
// Il personaggio ha 14 animazioni e NESSUNA arriva piu' da un file esterno:
// le quattro direzioni si ricavano da quelle che il pacchetto ha sempre avuto
// (Walk, Run, Run_Back, Run_Left, Run_Right) piu' CrouchWalk, costruita in
// Blender a suo tempo. Le tre camminate laterali/indietro e le tre
// accovacciate prese da Mixamo SONO STATE TOLTE dal GLB
// (tools/alleggerisci-glb.py): pesavano 360 KB grezzi e 103 KB sul filo, per
// direzioni che si ottengono con due trucchi a costo zero.
//
//  clip   quale animazione del GLB suonare. La stessa clip serve piu' caselle:
//         Walk fa avanti E indietro, Run_Left fa il passo laterale sia
//         camminando sia correndo sia accovacciati — cambia solo il RITMO.
//  verso  +1 avanti, -1 A ROVESCIO. Il tempo delle clip lo scrive il Player
//         (timeScale 0, time da una fase comune), quindi "al contrario"
//         costa un segno: la fase scorre indietro e i piedi restano
//         piantati, che e' esattamente come si cammina all'indietro.
//  vel    velocita' del piede d'appoggio a clip in tempo reale, MISURATA in
//         Blender in unita' di gioco (il personaggio e' alto 3.34). Il gioco
//         suona la clip a (velocita' vera / vel) cosi' i piedi non slittano.
//         Verifica del metodo: Walk misura 3.00, cioe' la velocita' di
//         camminata del gioco.
//  fase   a che punto del ciclo (0..1) il piede DESTRO e' piu' in alto. Le
//         caselle si mescolano (una diagonale e' avanti + di lato) e devono
//         avere lo stesso piede in aria, o una gamba passa dentro l'altra.
//         Vale anche a rovescio: la fase scorre all'indietro dallo stesso
//         istante.
//  piega  la clip di base e' IN PIEDI e ci va sommata l'accovacciata
//         additiva (Crouch). Serve solo al passo laterale accovacciato: per
//         quello in avanti e indietro la piega ce l'ha CrouchWalk, e
//         sommarla la raddoppierebbe.
//
// NIENTE CAMPO `testa`: prima ogni clip portava la posizione media della
// testa, misurata in Blender, perche' il corpo andava spostato in modo che
// la testa restasse sotto la camera. Ora quella misura la fa il Player
// leggendo l'osso Head a ogni fotogramma (vedi "L'OCCHIO STA SULLA TESTA"
// in Player.jsx): funziona con qualunque clip, e aggiungerne una non
// richiede piu' di rimisurare niente.
// ============================================================

export const VOCI = [
  // --- in piedi ---
  { fam: 'cammina', dir: 'avanti',   clip: 'Walk',       verso:  1, vel: 3.00, fase: 0.100 },
  // indietro = la camminata A ROVESCIO. I piedi spingono nel verso opposto e
  // restano a contatto col pavimento: e' il backpedal dei giochi in prima
  // persona, e non costa un byte.
  { fam: 'cammina', dir: 'indietro', clip: 'Walk',       verso: -1, vel: 3.00, fase: 0.100 },
  // di lato = le corse laterali del pacchetto, RALLENTATE al passo (0.41x).
  // Sono vere falcate laterali con le gambe che si scavalcano, che una clip
  // in avanti non puo' imitare in nessun modo.
  { fam: 'cammina', dir: 'sinistra', clip: 'Run_Left',   verso:  1, vel: 6.57, fase: 0.000 },
  { fam: 'cammina', dir: 'destra',   clip: 'Run_Right',  verso:  1, vel: 6.57, fase: 0.542 },

  // --- di corsa (tutte del pacchetto) ---
  { fam: 'corre',   dir: 'avanti',   clip: 'Run',        verso:  1, vel: 6.57, fase: 0.542 },
  { fam: 'corre',   dir: 'indietro', clip: 'Run_Back',   verso:  1, vel: 6.64, fase: 0.360 },
  { fam: 'corre',   dir: 'sinistra', clip: 'Run_Left',   verso:  1, vel: 6.57, fase: 0.000 },
  { fam: 'corre',   dir: 'destra',   clip: 'Run_Right',  verso:  1, vel: 6.57, fase: 0.542 },

  // --- accovacciati ---
  { fam: 'giu',     dir: 'avanti',   clip: 'CrouchWalk', verso:  1, vel: 3.08, fase: 0.455 },
  { fam: 'giu',     dir: 'indietro', clip: 'CrouchWalk', verso: -1, vel: 3.08, fase: 0.455 },
  // DI LATO ACCOVACCIATI SI USA LA STESSA CrouchWalk. Prima c'era la falcata
  // laterale in piedi con sopra la piega additiva, ed era sbagliato: i piedi
  // sono figli di Root e restano piantati, quindi tutta la piega finiva nella
  // caviglia. MISURATO in gioco, angolo alla caviglia: 84/74 gradi stando in
  // piedi, 107/35 e 98/46 nelle due direzioni laterali — piedi storpiati, ed
  // e' stato segnalato. Con CrouchWalk i piedi restano quelli giusti; in
  // cambio il passo va avanti mentre ci si sposta di lato, che e' un peccato
  // molto piu' piccolo e si nota solo guardandosi i piedi.
  // Il passo laterale accovacciato NON ESISTE in nessuna clip del modello: per
  // averlo davvero andrebbe costruito in Blender come si e' fatto per
  // CrouchWalk (blender/camminata_accovacciata.py).
  { fam: 'giu',     dir: 'sinistra', clip: 'CrouchWalk', verso:  1, vel: 3.08, fase: 0.455 },
  { fam: 'giu',     dir: 'destra',   clip: 'CrouchWalk', verso:  1, vel: 3.08, fase: 0.455 },
]

// Velocita' di ogni famiglia (unita' al secondo, andando avanti)...
export const VEL_FAM = { cammina: 3, corre: 6, giu: 2 }
// ...e quanto si va piano nelle altre direzioni. All'indietro e di lato non
// si va veloci come in avanti.
export const VEL_DIR = { avanti: 1, indietro: 0.7, sinistra: 0.9, destra: 0.9 }

export const DIREZIONI = ['avanti', 'indietro', 'sinistra', 'destra']
